export const getCheckedEmployeeIds = (items) => {
  const ids = []
  const traverse = (arr) => {
    for (const item of arr) {
      if (item.isEmployee && item.checked) {
        ids.push(item.id)
      } else if (item.children) {
        traverse(item.children)
      }
    }
  }
  traverse(items)
  return ids
}